import React, { Component } from "react";

import { Menu, Segment, Sidebar } from "semantic-ui-react";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faLayerGroup,
  faWindowClose,
  faChartBar,
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from "@fortawesome/free-solid-svg-icons";
import TreeNode from "./TreeNodeV2Flux";
import MapView from "./MapViewV2Flux";
import menus from "../Helpers/menus";
import axios from 'axios'
import domain from "../../domain";
import data from '../assets/data';
import Markers from './VenueMarkers';
import colors from "../../colors";
import PickerPanel from 'rc-picker';
import 'rc-picker/assets/index.css';
import { FadeLoader } from "react-spinners";

import { Rnd } from "react-rnd";
import { connect } from "react-redux";
import WBPopup from "./WBPopup";
import EBPopuup from "./EBPopup";
import pagecontent from "../Helpers/ETContent";
import AboutModal from "../../GeoportalModal";

import moment, { Moment } from 'moment'
import {
  modeChange,
  getETDates,
  onSlide,
  setSelectedMenu,
  setSelectedLayer,
  // onClickSlideLeft,
  // onClickSlideRight,
  handleDateChange,
  onMapClick,
  toggleVisibleGraphPanel,
  toggleSelectedNodeStatus,
  setLegend,
  // sidebarToggle,
  technicalNodeToggle,
  disclaimerToggle,
  // EBPToggle,
  handleDialogClose,
  getWidth
} from "../../redux_components/actions/ETActions";
library.add(
  faLayerGroup,
  faWindowClose,
  faChartBar,
  faAngleDoubleLeft,
  faAngleDoubleRight
);


class MapContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: true,
      india_states_boundary: null,
      modal: true,
      layerExist: true,
      wms_url_base_layers: `${domain.Geoserver}geoserver/base-layers/wms`,
      wms_url_default: `${domain.Geoserver}geoserver/evapotranspiration/wms`,
    };
  }
  componentDidMount() {
    this.getIndiaStatesBoundary();
    this.props.getWidth();
    // console.log(window.innerWidth);
    // if (window.innerWidth > 1000) {

    //   this.setState({
    //     visible:false
    //   });
    // }
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.date !== prevProps.date) {
      this.props.setSelectedLayer(this.props.selectedMenu);
    }
  }
  getIndiaStatesBoundary = () => {
    axios.post(`${domain.DBServer}/get-india-states-boundary`).then((result) => {
      if (result) {
        this.setState({
          india_states_boundary: result.data[0].india_boundary,
        });
      }
    });
  };

  // toggle = () => {
  //   this.setState({
  //     modal: !this.state.modal,

  //   });

  // };

  render() {
    let params = new URLSearchParams(this.props.location.search);

    // let menuList = menus.mapSideBar.map((child) => {
    //   return (
    //     <div style={{ padding: "5px" }} key={child.id}>
    //       <TreeNode
    //         data={child}
    //         setSelectedLayer={this.props.setSelectedLayer}
    //         setSelectedMenu={this.props.setSelectedMenu}
    //         margin={0}
    //         handleDateChange={this.props.handleDateChange}
    //         color={colors["sidebar-main-menu"]}
    //         selectedLayerLink={params.get("selected")}
    //         toggleSelectedNodeStatus={this.props.toggleSelectedNodeStatus}
    //         selectedNodeStatus={this.props.selectedNodeStatus}
    //         selectedMenu={this.props.selectedMenu}
    //         // EBPToggle={this.props.EBPToggle}
    //         date={this.props.date}
    //         availableDates={this.props.availableDates}
    //         inlinemode={this.props.inlinemode}
    //         modeChange={this.props.modeChange}
    //       // getAvailableDates={this.getAvailableDates.bind(this)}
    //       />
    //     </div>
    //   );
    // });
    //   console.log(this.props.history)

    return (
      <div
        style={{ backgroundColor: "#ffffff", height: "100%" }}
        ref={(ref) => {
          this._menuBlock = ref;
        }}
      >
        {/* <AboutModal
          modal={this.props.etmodal}
          toggle={this.props.toggle}
          title={pagecontent.title}
          bodycontent={pagecontent.bodycontent}
          link={pagecontent.link}
        /> */}
        <Sidebar.Pushable
          as={Segment}
          style={{
            marginTop: "0px",
            backgroundColor: "#FFFFFFF",
            border: "0px",
          }}
        >
          

          <Sidebar.Pusher
            dimmed={false}
            style={{ height: "100%", border: "0px" }}
          >
            <Segment
              basic
              style={{
                width: "100%",
                height: "100%",
                padding: "2px",
                border: "0px",
                margin: "0px",
              }}
            >
              <MapView
                india_states_boundary={this.state.india_states_boundary}
                latlng={this.props.latlng}
                showInfo={this.props.showInfo}
                pointInfo={this.props.pointInfo}
                legendVisible={this.props.legendVisible}
                displayLegend={this.displayLegend}
                // markerPosition={[28.613, 77.209]}
                selected={this.props.selectedMenu}
                chartData={this.props.chartData}
                chartloading={this.props.chartloading}
                setLegend={this.props.setLegend}
                selectedLayer={this.props.selectedLayer}
                // visibleLeft={this.props.visible}
                // visibleGraphPanel={this.props.visibleGraphPanel}
                // handleAnimationChange={this.props.sidebarToggle}
                handleVisibleGraphPanelOnMapClick={
                  this.handleVisibleGraphPanelOnMapClick
                }
                toggleVisibleGraphPanel={this.props.toggleVisibleGraphPanel}
                onMapClick={this.props.onMapClick}
                setStateInfo={this.setStateInfo}
                // activeDate ={this.state.date}

                activeDate={moment(
                  this.props.availableDates[this.props.slideTracker],
                  "YYYYMMDD"
                ).format("D MMM YYYY")}
                makeChartDataAvailableDays={
                  this.props.makeChartDataAvailableDays
                }
               
              />
            </Segment>
           

          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  availableDates: state.ETState.dates,
  date: state.ETState.date,
  slideTracker: state.ETState.slideTracker,
  latlng: state.ETState.latlng,
  selectedMenu: state.ETState.selectedMenu,
  selectedLayer: state.ETState.selectedLayer,
  legendVisible: state.ETState.legendVisible,
  chartData: state.ETState.chartData,
  showInfo: state.ETState.showInfo,
  // visibleGraphPanel: state.ETState.visibleGraphPanel,
  loading: state.ETState.loading,
  pointInfo: state.ETState.pointInfo,
  x: state.ETState.x,
  y: state.ETState.y,
  width: state.ETState.y,
  height: state.ETState.height,
  selectedNodeStatus: state.ETState.selectedNodeStatus,
  visible: state.ETState.visible,
  legend: state.ETState.legend,
  technicalnote: state.ETState.technicalnote,
  disclaimer: state.ETState.disclaimer,
  EB_popup: state.ETState.EB_popup,
  WB_popup: state.ETState.WB_popup,
  inlinemode: state.ETState.inlinemode
});
export default connect(mapStateToProps, {
  modeChange,
  getETDates,
  onSlide,
  setSelectedMenu,
  setSelectedLayer,
  // onClickSlideLeft,
  // onClickSlideRight,
  handleDateChange,
  onMapClick,
  toggleVisibleGraphPanel,
  toggleSelectedNodeStatus,
  // sidebarToggle,
  setLegend,
  // EBPToggle,
  technicalNodeToggle,
  disclaimerToggle,
  handleDialogClose,
  getWidth
})(MapContainer);
